/* eslint-disable no-unused-vars */
// https://vuex.vuejs.org/en/actions.html
import axios from "../axios-auth";
import axiosApi from "../axios-api";
import axiosOld from "../axios-old";
import router from "../router";

import splitByHead from "../utils/pulseIrrigationHelpers/splitByHead";

// const moment = require("moment-timezone");
import moment from "moment-timezone";

export default {
  signup({ commit }, authData) {
    // signup(authData) {
    axios
      .post("/signup", {
        username: authData.username,
        mail: authData.mail,
        userType: authData.userType,
        firstName: authData.firstname,
        lastName: authData.lastname,
        companyId: authData.companyId,
        phone: authData.phone,
        avatar: authData.avatar,
        accountStatus: authData.accountStatus,
        password: authData.password,

        // token: true
      })
      .then((res) => {
        console.log("singup succesfull", res.data);
        // commit('authUser', {
        //   token: res.data.accessToken,
        //   userId: res.data.localId,
        //   username: res.data.username
        // })
      })
      .catch((error) => console.log(error));
  },
  login({ commit }, authData) {
    // axios.post('/accounts:signInWithPassword?key=AIzaSyCk1A_jIGUsqad2bTkGFrZXttfa56MErHY', {
    axios
      .post("/signin", {
        username: authData.username,
        password: authData.password,
        // accessToken: true
      })
      .then((res) => {
        commit("authUser", {
          token: res.data.accessToken,
          userId: res.data.userData.id,
          userType: res.data.userData.userType,
          companyId: res.data.userData.companyId,
          mail: res.data.userData.mail,
          isUserLoggedIn: true,
          username: res.data.userData.username,
        });

        if (res.data.userData.userType === 'admin') {
          axiosApi
            .get(`/company/get-all-companies`).then((response) => {
              // .post(`http://localhost:3010/api/alert/alerts`, payload).then((response) => {
              let companies = response.data
              companies.sort((a, b) => (a.name > b.name ? 1 : -1));

              // console.log(">>>>>>>>>>>>>>>", payload, data)
              commit("companies", companies)
            })
        }

        router.push({
          name: "Dashboard",
        });
      })
      .catch((error) => console.log(error));
  },
  logout({ commit }, authData) {
    commit("signOutUser", {
      Token: null,
      userId: null,
      username: null,
      mail: null,
      userType: null,
      isUserLoggedIn: false,
      project: null,
      projectsArr: [],
      subProject: null,
      subProjectsArr: [],
      devices: [],
      data: null,
      data2: null,
      CEReports: null,
    });
    router.push({
      name: "signin",
    });
  },

  registerComapny({ commit }, data) {
    axiosApi
      .post("/company/insert-company", data)
      .then((res) => {
        console.log("Company registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  addProject({ commit }, data) {
    axiosApi
      .post("/project/insert-project", data)
      .then((res) => {
        console.log("Project registered!"), res.data;
      })
      .catch((error) => console.log(error));
  },

  addSubProject({ commit }, data) {
    axiosApi
      .post("/subproject/insert-subproject", data)
      .then((res) => {
        console.log("SubProject registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  addAgroUnit({ commit }, data) {
    axiosApi
      .post("/agrounit/insert-agrounit", data)
      .then((res) => {
        console.log("AgroUnit registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  // OLD API
  addTunel({ commit }, data) {
    axiosOld
      .post("/api/tunel", data)
      .then((res) => {
        alert("Tunel registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  addGeofence({ commit }, data) {
    axiosApi
      .post("/agrounit-geofence/insert-by-agrounit", data)
      .then((res) => {
        console.log("Geofence registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  addDevice({ commit }, data) {
    axiosApi
      .post("/device/insert-device", data)
      .then((res) => {
        console.log("Device registered!", res.data);
      })
      .catch((error) => console.log(error));
  },

  getProjectsArr({ commit }, id) {
    return new Promise((resolve, reject) => {
      axiosApi.get(`/project/get-all-by-company/${id}`).then(
        (response) => {
          let projects = response.data;

          let projectsArr = [];

          projects.forEach((element) => {
            projectsArr.push(element.name);
          });

          commit("projects", projects);
          commit("projectsArr", projectsArr);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  getSubProjectsArr({ commit }, id) {
    return new Promise((resolve, reject) => {
      axiosApi.get(`/subproject/get-all-by-project/${id}`).then(
        (response) => {
          let subProjects = response.data;
          // console.log(subProjects);

          let subProjectsArr = [];

          subProjects.forEach((element) => {
            subProjectsArr.push(element.name);
          });

          commit("subProjectsArr", subProjects);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  getAgroUnits({ commit }, id) {
    return new Promise((resolve, reject) => {
      axiosApi.get(`/agrounit/get-all-by-subproject/${id}`).then(
        (response) => {
          let agroUnits = response.data;
          // console.log(agroUnits);

          let agroUnitsArr = [];
          let agroUnitsIds = [];

          agroUnits.forEach((element) => {
            agroUnitsArr.push(element.name);
            agroUnitsIds.push(element.id);
          });

          commit("agroUnitsArr", agroUnits);
          // commit("agroUnitsIds", agroUnitsIds);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  getAgroUnitsOld({ commit }, id) {
    return new Promise((resolve, reject) => {
      axiosOld.get(`/api/parcelByAgroUnit/${id}`).then(
        (response) => {
          let agroUnits = response.data;
          // console.log(agroUnits);

          // let agroUnitsArr = [];
          let agroUnitsIds = [];

          agroUnits.forEach((element) => {
            // agroUnitsArr.push(element.name);
            agroUnitsIds.push(element.id);
          });

          commit("agroUnitsIds", agroUnitsIds);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  getDevicesArr({ commit }, id) {
    // alert(id)
    // CODE TO SHARE METEOROBOT WITH PADILLA
    if (id === 10) {
      axiosApi.get(`/device/get-all-in-subproject/${1}`).then((response) => {
        let devices = response.data;
        let meteo = null;
        devices.map((item) => {
          if (item.deviceType === "evvos_meteo") {
            meteo = item;
          }
        });
        if (meteo) {
          commit("meteo", meteo);
        }
      });
    } else if (id === 15) {
      // CODE TO SHARE METEOROBOT WITH AGROCIR
      axiosApi.get(`/device/get-all-in-subproject/${14}`).then((response) => {
        let devices = response.data;
        let meteo = null;
        devices.map((item) => {
          if (item.deviceType === "evvos_meteoV2") {
            meteo = item;
          }
        });
        if (meteo) {
          commit("meteo", meteo);
        }
      });
    }

    // let proDevices = null;
    // let lightDevices = null;
    axiosApi.get(`/device/get-all-in-subproject/${id}`).then((response) => {
      // console.log("RESONSEEE", response.data);
      let devices = response.data;

      let data = {
        labels: [],
        series: [[]],
      };

      let data2 = {
        labels: [],
        series: [[]],
      };

      let meteo = null;
      let newDevices = [];
      let agroBot = [];
      let agroBotComp = [];
      let agroBotBasic = [];
      let agroBotLight = [];
      let unaSense = [];
      let agroBotSoil = [];
      let agroBee = [];

      devices.map((item) => {
        if (item.deviceType === "evvos_meteo" || item.deviceType === "evvos_meteoV2") {
          meteo = item;
        } else if (item.deviceType === "agrobot_pro") {
          agroBot.push(item);
        } else if (item.deviceType === "agrobot_comp") {
          agroBotComp.push(item);
        } else if (item.deviceType === "evvos_pulse") {
          newDevices.push(item);
        } else if (item.deviceType === "agrobot_basic") {
          agroBotBasic.push(item);
        } else if (item.deviceType === "agrobot_light") {
          agroBotLight.push(item);
        } else if (item.deviceType === "agrobot_soil") {
          agroBotSoil.push(item);
        } else if (item.deviceType === "unaSense") {
          unaSense.push(item);
        } else if (item.deviceType === "agrobee") {
          agroBee.push(item);
        }
      });

      data.labels = newDevices.map((item) => item.name);

      data.series[0] = newDevices.map((x) => {
        if (x.specificTypeParameters === null) {
          return 0;
        } else {
          return (x.specificTypeParameters.humidity / 30) * 0.5 * 100;
        }
      });

      data2.labels = newDevices.map((item) => item.name);
      data2.series[0] = newDevices.map((x) => {
        if (x.specificTypeParameters === null) {
          return 0;
        } else {
          return x.specificTypeParameters.electricConductivity / 1000;
        }
      });

      if (meteo) {
        commit("meteo", meteo);
      }

      commit("dataArr", data);
      commit("dataArr2", data2);
      commit("agroBot", agroBot);
      commit("agroBotComp", agroBotComp);
      commit("agroBotBasic", agroBotBasic);
      commit("agroBee", agroBee);

      this.lightDevices = agroBotLight;
      this.proDevices = agroBot.concat(agroBotComp);
      this.proDevices = this.proDevices.concat(agroBotBasic);
      this.soilDevice = agroBotSoil
      this.unaSense = unaSense

      // this.soilDevice.reverse()
      this.soilDevice.sort((a, b) => (a.name > b.name ? 1 : -1));
      commit("agroBotSoil", this.soilDevice);

      this.proDevices.sort((a, b) => (a.name > b.name ? 1 : -1));
      commit("proDevices", this.proDevices);

      newDevices.sort((a, b) => (a.name > b.name ? 1 : -1));
      commit("devicesArr", newDevices);


      this.lightDevices.sort((a, b) => (a.name > b.name ? 1 : -1));
      commit("agroBotLight", this.lightDevices);


      this.unaSense.sort((a, b) => (a.name > b.name ? 1 : -1));
      commit("unaSense", this.unaSense);

    });
  },


  getAlerts({ commit }, id) {
    let payload = {
      "agroUnitId": id,
      "type": "TRUE"
    }
    axiosApi
      .post(`/alert/alerts`, payload).then((response) => {
        // .post(`http://localhost:3010/api/alert/alerts`, payload).then((response) => {
        let data = response.data
        // console.log(">>>>>>>>>>>>>>>", payload, data)
        commit('alerts', data)
      })
  },
  getAlertsResolved({ commit }, id) {
    let payload = {
      "agroUnitId": id,
      "type": "FALSE"
    }
    axiosApi
      .post(`/alert/alerts`, payload).then((response) => {
        // .post(`http://localhost:3010/api/alert/alerts`, payload).then((response) => {
        let data = response.data
        // console.log(">>>>>>>>>>>>>>>", payload, data)
        commit('alertsResolved', data)
      })
  },

  getTable({ commit }, rancho) {
    axiosOld.get(`/api/CeReportsDaily/${rancho}`).then((data) => {
      // console.log(data);
      commit("CEReports", data.data);
    });
    axiosOld.get(`/api/IrrigationReportsDaily/${rancho}`).then((data) => {
      // console.log(data);
      commit("CEReports", data.data);
    });
  },

  getIrrigationInstructions({ commit }, payload) {
    // console.log("GET INSTRUCTIONS");
    // console.log("star5t", payload);
    return new Promise((resolve, reject) => {
      axiosApi
        .get(
          `/irrigation-instruction/get-all-by-subproject/${payload.subProjectId}?startDate=${payload.startDate}&endDate=${payload.endDate}`
        )
        .then(
          async (response) => {
            let pulses = [];
            let irrigationInstructions = response.data;
            // console.log("RESPONSE", irrigationInstructions);

            // for await (let element of irrigationInstructions) {
            //   let id = element.id;
            //   console.log("Id ins", id);
            //   let res = await axiosApi.get(
            //     `/pulse-instruction/get-all-by-irrigation-instruction/${id}`
            //   );
            //   console.log("RES", res, id, res.data[0].electricConductivity);
            //   let data = res.data;
            //   console.log("FETCH PULSES", data);
            //   data.head = element.head;
            //   pulses.push(data);
            // }

            let promises = irrigationInstructions.map(async (element) => {
              return await axiosApi.get(
                `/pulse-instruction/get-all-by-irrigation-instruction/${element.id}`
              );
            });
            pulses = (await Promise.all(promises)).map((p, i) => {
              let pConHead = [...p.data];
              pConHead.head = irrigationInstructions[i].head;
              return pConHead;
            });
            // console.log("2 pulses", pulses);

            let splitIrrigationInstructions = splitByHead([...response.data]);
            // console.log(
            //   "a_splitIrrigationInstructions",
            //   splitIrrigationInstructions
            // );

            commit("splitIrrigationInstructions", splitIrrigationInstructions);

            let splitPulses = splitByHead([...pulses]);

            // console.log("a_pulses", pulses);
            // console.log("a_splitPulses", splitPulses);

            commit("pulses", [...pulses]);
            commit("splitPulses", splitPulses);
            commit("irrigationInstructions", response.data);

            this.irrigationInstructions = [...response.data];

            this.splitIrrigationInstructions = [...splitIrrigationInstructions];

            this.splitPulses = [...splitPulses];
            // console.log("splitPulses:", this.splitPulses);

            this.initialTimes = [[], []];

            if (
              this.splitIrrigationInstructions[0] &&
              this.splitIrrigationInstructions[0][0].initialTime
            ) {
              this.initialTimes[0] = this.splitIrrigationInstructions[0][0].initialTime;
            }

            if (
              this.splitIrrigationInstructions[1] &&
              this.splitIrrigationInstructions[1][0].initialTime
            ) {
              this.initialTimes[1] = this.splitIrrigationInstructions[1][0].initialTime;
            }

            let pulsesArr = [];
            let pulsesHeaders = [];

            // console.log("test", this.splitPulses);

            if (this.splitPulses[0] !== 0) {
              this.splitIrrigationInstructions.map((irrInstByHead, headInd) => {
                let arr = [];
                irrInstByHead.forEach((irrInts, indexNew) => {
                  // console.log("irrInst", irrInts);
                  // element.initialTime = this.initialTimes[i];
                  if (this.splitPulses[headInd] !== 0) {
                    arr.push([...this.splitPulses[headInd][indexNew]]);
                  }
                });
                pulsesArr.push(arr);
                irrInstByHead.push({});
                irrInstByHead.push({});
              });

              // console.log("xxx", pulsesArr);

              // CREATES TABLE HEADERS
              pulsesArr.forEach((element, i) => {
                pulsesHeaders.push([]);
                element[0].forEach((x, index) => {
                  pulsesHeaders[i].push(
                    {
                      text: `P. ${index + 1}`,
                      index: `${index + 1}`,
                      align: "center",
                    },
                    { text: `CE ${index + 1}`, align: "center" }
                  );
                });
              });

              // CALCULATE MINUTES PER PULSE PERCENTAJE
              let pulsesTable = [];
              let newTimes = [];

              let newPulseAr = [...pulsesArr];

              // pulsesArr.forEach((pulsesByHead, index) => {
              newPulseAr.forEach((pulsesByHead, index) => {
                pulsesTable.push([]);
                // console.log("pulsesTable", pulsesTable);

                pulsesByHead.forEach(
                  async (pulsesByAgroUnit, agroUnitIndex) => {
                    pulsesTable[index].push(
                      pulsesByAgroUnit.map((singlePulse) => {
                        // console.log("pulsesByAgroUnit", pulsesByAgroUnit, agroUnitIndex);
                        if (agroUnitIndex == 0) {
                          newTimes.push([]);
                        }

                        singlePulse.totalMin =
                          (this.splitIrrigationInstructions[index][
                            agroUnitIndex
                          ].milliliters *
                            singlePulse.percentage) /
                          100 /
                          66.66;

                        // singlePulse.electricConductivity =
                        //   splitPulses[index][agroUnitIndex][
                        //     indexPulse
                        //   ].electricConductivity;

                        singlePulse.minFormated = moment()
                          .startOf("day")
                          .add(singlePulse.totalMin, "minutes")
                          .format("m[m]:ss[s]");
                        return { ...singlePulse };
                      })
                    );
                  }
                );

                // console.log("pulsesArr", pulsesArr);
                // console.log("pulsesArr", pulsesTable);

                this.pulsesTable = pulsesTable;
              });

              // CALCULATE INITIAL AND FINAL TIME
              pulsesTable.forEach((headPulses, headInd) => {
                let time = moment(this.initialTimes[headInd], "HH:mm");
                let accIrrForPulse = new Array(headPulses[0].length).fill(0);

                // Cantidad de pulsos
                headPulses.forEach((irrPulses) => {
                  irrPulses.forEach((pulse, pulInd) => {
                    if (pulse.id) accIrrForPulse[pulInd] += pulse.totalMin;
                  });
                });

                let acc = 0;

                let initialTime = accIrrForPulse.map((totalByPulse, j) => {
                  const inTime = moment(time, "HH:mm")
                    .add(acc, "minutes")
                    .format("HH:mm");

                  acc += totalByPulse + parseInt(headPulses[0][j].waitTime);

                  return {
                    minFormated: inTime,
                    acc,
                    electricConductivity: "",
                  };
                });

                let resultTime = initialTime.map((t, tInd) => {
                  let minFormated = moment(t.minFormated, "HH:mm")
                    .add(accIrrForPulse[tInd], "minutes")
                    .format("HH:mm");

                  return {
                    minFormated,
                    electricConductivity: "",
                  };
                });
                headPulses.push(initialTime);
                headPulses.push(resultTime);
              });

              // console.log("Pulses Table", pulsesTable);

              // console.log("Pulses", pulses);

              commit("pulsesTable", pulsesTable);
              commit("pulsesHeaders", pulsesHeaders);
            }

            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  },

  setPlaguesReports({ commit }, report) {
    commit("plaguesReports", report);
  },

  // getCompanies({ commit }) {
  //   axiosApi
  //     .get(`https://listener.rabiahostal.com.mx/api/company/get-all-companies`).then((response) => {
  //       // .post(`http://localhost:3010/api/alert/alerts`, payload).then((response) => {
  //       let companies = response.data
  //       // console.log(">>>>>>>>>>>>>>>", payload, data)
  //       commit("companies", companies)
  //     })
  // }
};
